import {
	array,
	intersect,
	literal,
	number,
	partial,
	record,
	string,
	struct,
	union,
} from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Path, Point } from '../../../../../ui/geometry';
import { HexColor } from '../../../../../ui/HexColor';

export const Request = intersect(partial({ id: iotsUtils.UUID }))(
	union(
		intersect(
			struct({
				type: literal('path'),
				name: string,
				color: HexColor,
				paths: array(Path),
				measurementValues: record(number),
			})
		)(
			partial({
				cutouts: array(Path),
			})
		),
		intersect(
			struct({
				type: literal('marker'),
				name: string,
				shape: union(
					literal('circle'),
					literal('square'),
					literal('gps'),
					literal('heart'),
					literal('star'),
					literal('hexagon'),
					literal('triangle'),
					literal('diamond'),
					literal('shield'),
					literal('bookmark'),
					literal('bell'),
					literal('pentagon')
				),
				points: array(Point),
			})
		)(
			partial({
				color: HexColor,
			})
		)
	)
);
